@file:OptIn(InternalResourceApi::class)

package mifos_mobile.feature.guarantor.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/mifos_mobile.feature.guarantor.generated.resources/"

internal val Res.string.add_guarantor: StringResource by lazy {
      StringResource("string:add_guarantor", "add_guarantor", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 41),
      ))
    }

internal val Res.string.city: StringResource by lazy {
      StringResource("string:city", "city", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 52, 20),
      ))
    }

internal val Res.string.delete_guarantor: StringResource by lazy {
      StringResource("string:delete_guarantor", "delete_guarantor", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 73, 48),
      ))
    }

internal val Res.string.dialog_are_you_sure_that_you_want_to_string: StringResource by lazy {
      StringResource("string:dialog_are_you_sure_that_you_want_to_string", "dialog_are_you_sure_that_you_want_to_string", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 122, 99),
      ))
    }

internal val Res.string.dismiss: StringResource by lazy {
      StringResource("string:dismiss", "dismiss", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 222, 27),
      ))
    }

internal val Res.string.error_validation_blank: StringResource by lazy {
      StringResource("string:error_validation_blank", "error_validation_blank", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 250, 58),
      ))
    }

internal val Res.string.first_name: StringResource by lazy {
      StringResource("string:first_name", "first_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 309, 34),
      ))
    }

internal val Res.string.guarantor_created_successfully: StringResource by lazy {
      StringResource("string:guarantor_created_successfully", "guarantor_created_successfully", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 344, 78),
      ))
    }

internal val Res.string.guarantor_deleted_successfully: StringResource by lazy {
      StringResource("string:guarantor_deleted_successfully", "guarantor_deleted_successfully", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 423, 78),
      ))
    }

internal val Res.string.guarantor_details: StringResource by lazy {
      StringResource("string:guarantor_details", "guarantor_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 502, 49),
      ))
    }

internal val Res.string.guarantor_type: StringResource by lazy {
      StringResource("string:guarantor_type", "guarantor_type", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 552, 42),
      ))
    }

internal val Res.string.guarantor_updated_successfully: StringResource by lazy {
      StringResource("string:guarantor_updated_successfully", "guarantor_updated_successfully", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 595, 78),
      ))
    }

internal val Res.string.internet_not_connected: StringResource by lazy {
      StringResource("string:internet_not_connected", "internet_not_connected", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 674, 82),
      ))
    }

internal val Res.string.last_name: StringResource by lazy {
      StringResource("string:last_name", "last_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 757, 29),
      ))
    }

internal val Res.string.no_guarantors: StringResource by lazy {
      StringResource("string:no_guarantors", "no_guarantors", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 787, 41),
      ))
    }

internal val Res.string.office_name: StringResource by lazy {
      StringResource("string:office_name", "office_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 829, 35),
      ))
    }

internal val Res.string.phone_number: StringResource by lazy {
      StringResource("string:phone_number", "phone_number", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 865, 36),
      ))
    }

internal val Res.string.screen_guarantor_add: StringResource by lazy {
      StringResource("string:screen_guarantor_add", "screen_guarantor_add", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 902, 56),
      ))
    }

internal val Res.string.screen_guarantor_details: StringResource by lazy {
      StringResource("string:screen_guarantor_details", "screen_guarantor_details", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 959, 64),
      ))
    }

internal val Res.string.screen_guarantor_list: StringResource by lazy {
      StringResource("string:screen_guarantor_list", "screen_guarantor_list", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1024, 57),
      ))
    }

internal val Res.string.submit: StringResource by lazy {
      StringResource("string:submit", "submit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1082, 22),
      ))
    }

internal val Res.string.tap_to_add_guarantor: StringResource by lazy {
      StringResource("string:tap_to_add_guarantor", "tap_to_add_guarantor", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1105, 56),
      ))
    }

internal val Res.string.update_guarantor: StringResource by lazy {
      StringResource("string:update_guarantor", "update_guarantor", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1162, 48),
      ))
    }

internal val Res.string.view_guarantor: StringResource by lazy {
      StringResource("string:view_guarantor", "view_guarantor", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1211, 42),
      ))
    }

internal val Res.string.yes: StringResource by lazy {
      StringResource("string:yes", "yes", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1254, 15),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("add_guarantor", Res.string.add_guarantor)
  map.put("city", Res.string.city)
  map.put("delete_guarantor", Res.string.delete_guarantor)
  map.put("dialog_are_you_sure_that_you_want_to_string", Res.string.dialog_are_you_sure_that_you_want_to_string)
  map.put("dismiss", Res.string.dismiss)
  map.put("error_validation_blank", Res.string.error_validation_blank)
  map.put("first_name", Res.string.first_name)
  map.put("guarantor_created_successfully", Res.string.guarantor_created_successfully)
  map.put("guarantor_deleted_successfully", Res.string.guarantor_deleted_successfully)
  map.put("guarantor_details", Res.string.guarantor_details)
  map.put("guarantor_type", Res.string.guarantor_type)
  map.put("guarantor_updated_successfully", Res.string.guarantor_updated_successfully)
  map.put("internet_not_connected", Res.string.internet_not_connected)
  map.put("last_name", Res.string.last_name)
  map.put("no_guarantors", Res.string.no_guarantors)
  map.put("office_name", Res.string.office_name)
  map.put("phone_number", Res.string.phone_number)
  map.put("screen_guarantor_add", Res.string.screen_guarantor_add)
  map.put("screen_guarantor_details", Res.string.screen_guarantor_details)
  map.put("screen_guarantor_list", Res.string.screen_guarantor_list)
  map.put("submit", Res.string.submit)
  map.put("tap_to_add_guarantor", Res.string.tap_to_add_guarantor)
  map.put("update_guarantor", Res.string.update_guarantor)
  map.put("view_guarantor", Res.string.view_guarantor)
  map.put("yes", Res.string.yes)
}
